import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { ListItemsState, ListItemsTypes } from './types';

const INITIAL_STATE: ListItemsState = {
    listItems: undefined,
    loading: true,
    hasError: false,
    error: undefined,
    success: false,
};

const reducer: Reducer<ListItemsState> = (state: ListItemsState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case ListItemsTypes.ADD_TO_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ListItemsTypes.ADD_TO_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case ListItemsTypes.ADD_TO_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                hasError: true,
            };
        case ListItemsTypes.DELETE_FROM_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ListItemsTypes.DELETE_FROM_LIST_SUCCESS:
            return {
                ...state,
                listItems: state.listItems && state.listItems.filter((i) => i.id !== action.payload),
                loading: false,
            };
        case ListItemsTypes.DELETE_FROM_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                hasError: true,
            };
        case ListItemsTypes.GET_LIST_ITEMS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ListItemsTypes.GET_LIST_ITEMS_SUCCESS:
            return {
                ...state,
                loading: false,
                listItems: action.payload,
            };
        case ListItemsTypes.GET_LIST_ITEMS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                hasError: true,
            };
        case ListItemsTypes.LIST_ITEMS_CLEAR:
            return { ...INITIAL_STATE };
        case ListItemsTypes.ADD_TO_LIST_CLEAR:
            return {
                ...state,
                success: false,
            };
        default:
            return state;
    }
};

export default reducer;
